import Alpine from "alpinejs";

import "../../../../JvMTECH.Components/Resources/Private/Main.js";
import "../Fusion/Prototypes/LazyContent/LazyContent.js";

if (!window.Alpine) {
    window.Alpine = Alpine;
}
Alpine.start();

if (process.env.NODE_ENV === "development") {
    console.log("JvMTECH.Base Main.js loaded");
}
